import React, { useState } from 'react'
import { Card, Form, Button, Container } from 'react-bootstrap';
import './invoice-styles.css'
import { TbFileInvoice } from "react-icons/tb";
import {  useNavigate } from 'react-router-dom';
import useStartSingleClaim from '../../hook/useStartSingleClaim';
import useSetExplanation from '../../hook/useSetExplanation';
import useCompleteClaimInvoice from '../../hook/useCompleteClaimInvoice';
import { toast } from 'react-toastify';







const InvoicePage = () => {

    const navigate = useNavigate()
    const {explanationFunc} = useSetExplanation()
    const [selectedReasonId, setSelectedReasonId] = useState()
    const {completeClaim} = useCompleteClaimInvoice()
    const [note, setNote] = useState('')


    const reasons = [
        { id: 0, reason: 'İade talebim için kullanacağım' },
        { id: 1, reason: 'Faturam gelmedi' },
        { id: 2, reason: 'Faturamda hata var' },
        { id: 3, reason: 'Faturamı kaybettim' },
        { id: 4, reason: 'Garanti/servis süreci için kullanacağım' },
        { id: 5, reason: 'Paket bana ulaşmadı' },
        { id: 6, reason: 'Pakette eksik ürün var' }

      ];


        const handleStartClaim = (id)=>{
          explanationFunc(id)
          console.log("id", id)
          setSelectedReasonId(id)
        }

        const handleclick = () => {
          if (!selectedReasonId) {
            toast.error("Lütfen bir seçenek seçiniz.");
          } else {
            navigate("/invoice-summary");
            completeClaim(note);
          }
        };

      const handleNoteChange = (e) => {
        setNote(e.target.value);
      };


  return (

    <Container className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
    <Card className='card-invoice' >
       <Card.Body >
         <Card.Title >
            Fatura Talebi
         </Card.Title>
         <Form>
        <Form.Group>
          <Form.Label className='title-invoice'>Talep Nedeni <span style={{fontSize:'13px', fontWeight:'normal'}}>(zorunlu)</span> </Form.Label>
          {reasons.map((item) => (
                <div
                    key={item.id}
                    className={`reason-item ${selectedReasonId === item.id ? 'selected' : ''}`}
                    onClick={() => handleStartClaim(item.id)} 
                >
                    {item.reason}
                </div>
                ))}
        </Form.Group>
        <Form.Group controlId="exampleForm.ControlTextarea1" className='text-area-invoice'>
          <Form.Label  className='title-invoice'>Açıklama <span style={{fontSize:'13px', fontWeight:'normal'}}>(isteğe bağlı)</span></Form.Label>
          <Form.Control value={note}
              onChange={handleNoteChange} as="textarea" rows={3}  className='text-area-placeholder' placeholder='konu ile ilgili detaylar...'/>
        </Form.Group>
      </Form>
          <Button style={{width:'100%', marginTop:'30px', marginBottom:'20px'}} onClick={handleclick}
          //  disabled={!selectedReasonId}
          >onay</Button>
       </Card.Body>
     
     </Card>
   </Container>
  )
}

export default InvoicePage